import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
  width: 100%;
  border-left: 1px solid #E7EBEB;
`

export default Wrapper(template);